import { AttendanceSheetStatusEnum, attendanceSheetStatusEnumInFull } from '../../../../enums/attendance-sheet-status.enum';
import { AttendanceSheetStatusIconByStatus } from '../../../components/IconeStatus';

type Props = {
  status: AttendanceSheetStatusEnum | undefined;
  textoBtnA?: string;
  textoBtnB?: string;
  isExecuting: boolean;
  onAbrirModalPrimario: () => void;
  onAbrirModalSecundario: () => void;
  onAbrirJustificativaCorrecao: () => void;
};

/**
 * Coluna com trilha de status, rótulo textual e botões de ação da folha.
 */
export default function AttendanceSheetStatusActionsColumn({
  status,
  textoBtnA,
  textoBtnB,
  isExecuting,
  onAbrirModalPrimario,
  onAbrirModalSecundario,
  onAbrirJustificativaCorrecao,
}: Props) {
  return (
    <div className="col-md-4 d-flex flex-column align-items-end gap-2">
      <div className="d-flex flex-wrap justify-content-end gap-1 align-items-center">
        <AttendanceSheetStatusIconByStatus
          status={AttendanceSheetStatusEnum.EM_PREENCHIMENTO}
          folhaStatus={status}
        />
        {status === AttendanceSheetStatusEnum.EM_CORRECAO ? (
          <span
            role="button"
            tabIndex={0}
            onClick={onAbrirJustificativaCorrecao}
            onKeyDown={(e) => e.key === 'Enter' && onAbrirJustificativaCorrecao()}
            style={{ cursor: 'pointer' }}
            title="Em correção. Clique para ver a justificativa."
          >
            <AttendanceSheetStatusIconByStatus
              status={AttendanceSheetStatusEnum.EM_CORRECAO}
              folhaStatus={status}
            />
          </span>
        ) : (
          <AttendanceSheetStatusIconByStatus
            status={AttendanceSheetStatusEnum.EM_CORRECAO}
            folhaStatus={status}
          />
        )}
        <AttendanceSheetStatusIconByStatus
          status={AttendanceSheetStatusEnum.AGUARDANDO_ASSINATURA}
          folhaStatus={status}
        />
        <AttendanceSheetStatusIconByStatus
          status={AttendanceSheetStatusEnum.AGUARDANDO_REVISAO}
          folhaStatus={status}
        />
        <AttendanceSheetStatusIconByStatus
          status={AttendanceSheetStatusEnum.CONCLUIDA}
          folhaStatus={status}
        />
      </div>

      <div className="text-end w-100">
        <strong>{attendanceSheetStatusEnumInFull(status)}</strong>
      </div>

      <div className="d-flex justify-content-end gap-2 flex-wrap">
        {textoBtnB && (
          <button
            type="button"
            className="btn btn-outline-danger"
            disabled={isExecuting}
            onClick={onAbrirModalSecundario}
          >
            {textoBtnB}
          </button>
        )}
        {textoBtnA && (
          <button
            type="button"
            className="btn btn-outline-success"
            disabled={isExecuting}
            onClick={onAbrirModalPrimario}
          >
            {textoBtnA}
          </button>
        )}
      </div>
    </div>
  );
}
